// assetLibrary.js — static searchable catalog for the Add-asset popup.
// Crypto keyed WITH -USD, stocks keyed BARE — matching followedCoins/livePrices keys.
// This is the ONLY source the popup searches. Swapping this for a live API fetch later
// is a separate build; the popup reads from ASSET_LIBRARY regardless of source.
//
// The catalog is now a thin re-export of the single source of truth in assetUniverse.js
// (shared with the CJS worker's scan universe via universe.bundle.cjs) so the selectable
// catalog and the scanned universe can never drift. Shape { symbol, name, type } unchanged.
import { ASSET_UNIVERSE } from "./assetUniverse";

export const ASSET_LIBRARY = ASSET_UNIVERSE;
